<!--
 * @Author: wzh
 * @Date: 2023-03-08 11:51:09
 * @Description: 获取酒城e通 token
-->
<template>
	<div class=""></div>
</template>

<script>
export default {
	name: "ThirdToken",
	mounted() {
		this.init();
	},
	methods: {
		init() {
			lightAppJssdk.user.getTicket({
				success: function(data) {
					if (data == "未登录") {
						alert("当前未登录,无用户信息");
					} else {
						let obj = JSON.parse(data);
						window.location.href = `${window.ipConfigUrl.thirdUrl}${obj.data.access_token}`;
					}
				},
				fail: function(data) {
					alert(data);
				},
			});
		},
	},
};
</script>

<style lang="scss" scoped></style>
